import { FC, Fragment } from 'react'

import Typography from '@/ui/components/typography'

import { Container, Divider, List } from './DomainDetailList.styles'
import { DomainDetailListProps } from './DomainDetailList.types'

const DomainDetailList: FC<DomainDetailListProps> = ({
    title,
    items,
    testId,
    itemTestId,
    placeholder,
}) => {
    if (items.length === 0 && !placeholder) {
        return null
    }

    return (
        <Container>
            <Typography
                className="title"
                component="h3"
                variant="s-regular"
                color="inherit"
            >
                {title}
            </Typography>
            <List data-testid={testId}>
                {items.length === 0 && (
                    <Typography variant="s-regular">{placeholder}</Typography>
                )}
                {items.map((value, idx) => (
                    <Fragment key={value}>
                        <Typography variant="s-regular" testId={itemTestId}>
                            {value}
                        </Typography>
                        {idx < items.length - 1 && (
                            <Divider variant="s-regular" component="span">
                                |
                            </Divider>
                        )}
                    </Fragment>
                ))}
            </List>
        </Container>
    )
}

export default DomainDetailList
